import { useRouteParams } from '@components/router';
import { IcoChatSolid } from '@components/icons';
import { URLS } from 'shared/urls';
import { genericDiscussionCategoryIds } from 'shared/consts';
import { State } from './index';

type Category = State['categories'][0];

function Pill({ category }: { category: Category }) {
  const { courseId, categoryId: selectedCategory = 'all', courseSlug } = useRouteParams();
  const isSelected = selectedCategory === category.id;
  const isAll = category.id === genericDiscussionCategoryIds.all;

  return (
    <a
      href={URLS.student.coursePage({
        course: {
          id: courseId,
          title: courseSlug,
        },
        page: `discussions/${category.id}`,
      })}
      class={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors ${
        isSelected
          ? 'bg-indigo-50 text-indigo-700 font-medium ring-1 ring-indigo-200'
          : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
      }`}
    >
      {isAll ? (
        <IcoChatSolid class="w-3.5 h-3.5 flex-shrink-0 opacity-60" />
      ) : (
        <span
          style={{ backgroundColor: category.color }}
          class="w-2.5 h-2.5 rounded-full flex-shrink-0"
        />
      )}
      <span>{category.title}</span>
      {category.numDiscussions > 0 && (
        <span class={`text-xs ${isSelected ? 'text-indigo-500' : 'text-gray-400'}`}>
          {category.numDiscussions}
        </span>
      )}
    </a>
  );
}

export function CategoryPills({ categories }: { categories: State['categories'] }) {
  return (
    <div class="flex flex-wrap gap-2 mb-6">
      {categories.map((category) => (
        <Pill key={category.id} category={category} />
      ))}
    </div>
  );
}
